export default __webpack_public_path__ + "static/gs-python-code-404094bd98e68b250580c3dcb8a5ecac.webp";